import {
  Button
  Card
  Col
  Divider
  Layout
  Row
  Space
  Tabs
  Tag
  Typography
} from 'antd'
import Feather from '@sysunite/react-feather'
import { useRouteMatch } from 'react-router'
import { MergeRequest } from 'Model'
import { useEffect, useState } from 'react'
import moment from 'moment'
import Changelist from '../Compare/Changelist'
import WeaverService from 'Services/WeaverService'
import './Detail.scss'


{ Title, Paragraph } = Typography

export default ->

  { params: { mrId }} = useRouteMatch()
  [mergeRequest, setMergeRequest] = useState()
  [merging, setMerging] = useState(false)
  [checkingMerge, setCheckingMerge] = useState(false)
  [mergeable, setMergeable] = useState(false)
  [approving, setApproving] = useState(false)

  useEffect(->
    (->
      setCheckingMerge(true)
      setMergeRequest(mr = await MergeRequest.load(mrId))
      try
        target = await Weaver.Branch.load(mr.get('target'))
        source = await Weaver.Branch.load(mr.get('source'))
        await Weaver.Branch.mergeBranches(target, source, true)
        setMergeable(true)
      catch e
        setMergeable(false)
      setCheckingMerge(false)
    )()
    undefined
  , [])

  getApprovals = ->
    mergeRequest.get('approvedBy') or []

  currentUser = ->
    Weaver.getInstance().currentUser()

  getStatus = ->
    switch status = mergeRequest.get('status')
      when 'open'
        color = 'green'
      when 'merged'
        color = 'blue'
      when 'closed'
        color = 'red'

    <Tag color={color}>{ status }</Tag>

  merge = ->
    setMerging(true)
    try
      targetBranch = new Weaver.Branch(mergeRequest.get('target'))
      sourceBranch = new Weaver.Branch(mergeRequest.get('source'))
      mergeRequest.set('changes', await Weaver.Branch.diffBranches(targetBranch, sourceBranch), { dataType: 'json' })
      await Weaver.Branch.mergeBranches(targetBranch, sourceBranch)
      mergeRequest.set('status', 'merged')
      mergeRequest.set('mergedBy', currentUser().id())
      await mergeRequest.save()
    catch e
      console.log e
    setMerging(false)

  setApproval = ->
    try
      setApproving(true)
      userId = currentUser().id()
      approvedBy = mergeRequest.get('approvedBy') or []
      if userId in approvedBy
        mergeRequest.set('approvedBy', _.without(approvedBy, userId), { dataType: 'json' })
      else
        mergeRequest.set('approvedBy', [
          approvedBy...
          userId
        ], { dataType: 'json' })
      await mergeRequest.save()
      setApproving(false)
    catch e
      console.log e

  getUserById = (id) ->
    user = WeaverService.currentProjectUsers[id]
    "#{user?.firstname} #{user?.lastname}"


  <Layout style={{ padding: '16px' }}>
    {
      if mergeRequest?
        status = mergeRequest.get('status')
        <>
          <Row>
            <Col>
              { getStatus() }
              created { moment(mergeRequest.createdAt()).fromNow() } by <b>{getUserById(mergeRequest.createdBy())}</b>
            </Col>
          </Row>
          <Divider />
          <Title level={3}>{ mergeRequest.get('title') }</Title>
          <Tabs style={{ background: 'inherit' }}>
            <Tabs.TabPane key="overview" tab="Overview">
              <Paragraph>{ mergeRequest.get('description') }</Paragraph>
              <Space size={16} direction="vertical">
                <Card bodyStyle={{ padding: '16px' }}>
                  <Row gutter={16} align="middle">
                    <Col>
                      <Feather size="2em" type="git-pull-request" />
                    </Col>
                    <Col>
                      Request to merge <b>{mergeRequest.get('source')}</b> into <b>{mergeRequest.get('target')}</b>
                    </Col>
                  </Row>
                </Card>
                <Card bodyStyle={{ padding: '16px' }}>
                  <Row gutter={16} align="middle">
                    <Col>
                      <Feather size="2em" type="user-check" />
                    </Col>
                    {
                      if status is 'open'
                        <Col>
                          <Button
                            data-testid="approve-mr"
                            loading={approving}
                            onClick={setApproval}
                            type={if currentUser().id() in getApprovals() then "danger" else "primary"}
                            ghost
                          >
                            {
                              if currentUser().id() in getApprovals()
                                "Revoke approval"
                              else
                                "Approve"
                            }
                          </Button>
                        </Col>
                    }
                    <Col>

                      {
                        if (approvals = getApprovals()).length > 0
                          <span>Approved by <b>{approvals.map(getUserById).join(', ')}</b></span>
                      }
                    </Col>
                  </Row>
                </Card>
                <Card bodyStyle={{ padding: '16px' }}>
                  <Row gutter={16} align="middle">
                    <Col>
                      <Feather size="2em" type={if mergeable then "check" else "x"} />
                    </Col>
                    <Col>
                      {
                        if status is 'open'
                          <Button
                            type="primary"
                            data-testid="merge-mr"
                            onClick={merge}
                            loading={merging or checkingMerge}
                          >
                            { if checkingMerge then "Checking ability to merge" else "Merge" }
                          </Button>
                        else if status is 'merged'
                          <span>Merged by <b>{getUserById(mergeRequest.get('mergedBy'))}</b></span>
                        else if status is 'closed'
                          "Closed by #{mergeRequest.get('closedBy')}"
                      }
                    </Col>
                  </Row>
                </Card>
              </Space>
            </Tabs.TabPane>
            <Tabs.TabPane key="changes" tab="Changes">
              <Card className="changelist-container">
                <Changelist
                  changes={mergeRequest.get('changes')}
                  source={mergeRequest.get('source')}
                  target={mergeRequest.get('target')}
                />
              </Card>
            </Tabs.TabPane>
          </Tabs>
        </>
    }
  </Layout>
